import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BotonExportarTablaComponent } from './components/boton-exportar-tabla/boton-exportar-tabla.component';



@NgModule({
	declarations: [BotonExportarTablaComponent],
	imports: [
		CommonModule,
	],
	exports: [
		BotonExportarTablaComponent
	],
})
export class ReutilizablesModule { }
